import type { IMarket } from "~/types/event";

import { getMarketGroupId } from "./buildMarketGroups";

export const getGroupedMarketIdsSelection = (
  markets: IMarket[],
  marketId?: string
): string[] => {
  const [firstMarket] = markets;
  const targetMarket =
    markets.find((market) => market.id === marketId) ?? firstMarket;

  if (!targetMarket) {
    return [];
  }

  const groupId = getMarketGroupId(targetMarket);

  return markets
    .filter((market) => getMarketGroupId(market) === groupId)
    .map(({ id }) => id);
};
